import * as Sentry from '@sentry/react';
import React, { createContext, type ReactNode, useRef, useState } from 'react';
import { useAuthClaims } from '../hooks/useAuthClaims';

export type AppLayoutContextType = {
  sidebarIsOpen: boolean;
  sidebarIsFixed: boolean;
  scrollRef: React.RefObject<HTMLDivElement> | null;
  setSidebarIsOpen: (value: boolean | ((prevVar: boolean) => boolean)) => void;
  setSidebarIsFixed: (value: boolean | ((prevVar: boolean) => boolean)) => void;
};

export const AppLayoutContext = createContext<AppLayoutContextType>({
  sidebarIsOpen: false,
  sidebarIsFixed: false,
  scrollRef: null,
  setSidebarIsFixed: () => {
    return;
  },
  setSidebarIsOpen: () => {
    return;
  },
});

export const AppLayoutContextProvider = ({ children }: { children: ReactNode }) => {
  const { pimAuthClaims } = useAuthClaims();
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const [sidebarIsFixed, setSidebarIsFixed] = useState(false);

  // TODO: SentryProvider wäre passender
  if (import.meta.env.VITE_APP_SENTRY_DSN) {
    Sentry.setUser({
      id: pimAuthClaims.getUser()?.uuid ?? '00000000-0000-0000-0000-000000000000',
      email: pimAuthClaims.getProfile()?.email ?? '',
      segment: pimAuthClaims.getOrganization()?.name ?? '',
    });
  }

  return (
    <AppLayoutContext.Provider
      value={{
        sidebarIsFixed,
        sidebarIsOpen,
        setSidebarIsOpen,
        setSidebarIsFixed,
        scrollRef,
      }}
    >
      {children}
    </AppLayoutContext.Provider>
  );
};
